// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"331":"3416537f","389":"e3b7a80a","605":"e911c74e","981":"fb628fca"}[chunkId] + ".css";
};